import React, { createContext, useContext, useLayoutEffect, useRef } from 'react';

// Gesperrte Knöpfe zeigen, nicht verstecken (SPEC VE-23, Entscheidung E-VE-7). In einer Sicht bleiben die
// Schreibknöpfe der Anzeigemenge sichtbar, sind aber gesperrt und nennen den Grund. Die Grenze sperrt jedes
// Bedienelement in ihrem Inhalt; lesende Bedienelemente (Suche, Blättern) tragen data-lesend. So muss kein
// Formular an die Sperre denken (NG-04); der Server sperrt ohnehin routerweit (VE-21).
// Abweichung A-11 (UMSETZUNG.md): eine Grenze statt Änderungen in Invitations, Branding, Roles, BillingPanel.
const ReadOnlyContext = createContext<{ gesperrt: boolean; grund: string }>({ gesperrt: false, grund: '' });
export const useWriteLock = () => useContext(ReadOnlyContext);

export function NurLesend({ grund, children }: { grund: string; children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const root = ref.current;
    if (!root) return;
    const sperren = () => {
      root.querySelectorAll<HTMLElement>('button, input, select, textarea').forEach(element => {
        if (element.closest('[data-lesend]')) return;
        if (!element.hasAttribute('disabled')) element.setAttribute('disabled', '');
        if (element.getAttribute('title') !== grund) element.setAttribute('title', grund);
        if (element.getAttribute('aria-disabled') !== 'true') element.setAttribute('aria-disabled', 'true');
      });
    };
    sperren();
    // React setzt disabled beim nächsten Rendern womöglich zurück; die Grenze setzt es wieder.
    const beobachter = new MutationObserver(sperren);
    beobachter.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'title', 'aria-disabled'] });
    return () => beobachter.disconnect();
  }, [grund]);
  return <ReadOnlyContext.Provider value={{ gesperrt: true, grund }}><div ref={ref} className="adm-nur-lesend">{children}</div></ReadOnlyContext.Provider>;
}
